import React from "react";
import { getActivityFeed_activityFeed as ActivityFeed } from "types/gql-types";

interface Props {
  activity: ActivityFeed;
}

const DocumentFeedItem:React.FC<Props> = ({ activity: { metadata } }) => (
  <div>Filename: {metadata?.filename}</div>
);

export default DocumentFeedItem;
